import { transformTableQueryForKy } from "../../helpers/tableHelpers";
import {
  OrderCustomFormTableQuery,
  OrderTableQuery,
} from "../../pages/orders/models";
import { privateGet } from "../clients/createPrivateClient";
import {
  CPOrderDetailQueryResult,
  TableResultCPOrder,
  TableResultCPOrderCustomForm,
} from "../models/unified";

export default {
  getOrders: async (query: OrderTableQuery) => {
    const result = await privateGet<TableResultCPOrder>(
      `customerPortal/order/v2`,
      {
        ...transformTableQueryForKy(query),
      },
    );

    return result;
  },
  getOrderDetail: async (orderId: string) => {
    const result = await privateGet<CPOrderDetailQueryResult>(
      `customerPortal/order/v2/${orderId}`,
    );

    return result;
  },
  getOrderCustomForms: async (query: OrderCustomFormTableQuery) => {
    const result = await privateGet<TableResultCPOrderCustomForm>(
      "customerPortal/orderCustomForm/v2",
      {
        ...transformTableQueryForKy(query),
      },
    );

    return result;
  },
};
